import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDPREMOPROJECT_SOURCE_ID = 'browardPremoProjectSource';

const source = {
  id: BROWARDPREMOPROJECT_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.PREMO_Projects`,
};

export default source;
